import { Environment } from '@interfaces/environments/environment';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://api.dev-1.silpovoyage.ua',
  gtagTrackingId: 'UA-57582325-3',
};
